export default __webpack_public_path__ + "static/media/robot.e117e061.svg";